import React, {createRef} from "react";
import {connect} from "react-redux";
import Menu from "../menu";
import {Table, Pagination, Button, DatePicker, Input} from "../../components";
import {axios, Globals, ENV} from "../../utils";
import PrinterIcon from "../../assets/icons/printer.png";

class PurchasesBook extends React.Component {
  state = {
    header: [
      "N° de\npedido",
      "Fecha",
      "RIF",
      "Nombre o\nrazón social",
      "N° de\nfactura",
      "N° de\ncontrol",
      "Nota de\ndébito",
      "Nota de\ncrédito",
      "Doc.\nafectado",
      "Total\n+ IVA",
      "Compras\nexentas",
      "Base\n16%",
      "IVA\n16%",
      "Base\n8%",
      "IVA\n8%",
      "Base\n31%",
      "IVA\n31%",
      "Retención\n75%",
      "Retención\n100%",
    ],
    form: {
      user_id: this.props.user.id,
      search: "",
      n_pedido: "",
      since: "",
      until: "",
    },
    page: 1,
    last_page: 1,
    data: [],
    dates: {
      minDate: "",
      maxDate: "",
    },
  };

  abortController = new AbortController();
  debounce = createRef();

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  load = async (page = 1) => {
    Globals.setLoading();

    try {
      const res = await axios.post(
        "admin/reports/providers?page=" + page,
        this.state.form,
      );
      this.setState({
        page,
        last_page: res.data.providers?.last_page || 1,
        data: res.data.providers?.data || [],
      });
    } catch (error) {
      console.log(error);
    }

    Globals.quitLoading();
  };

  change = async (value, target) => {
    await this.setState((s) => ({form: {...s.form, [target]: value}}));
    this.load(1);
  };

  changeText = (e, target) => {
    const value = e && e.target !== undefined ? e.target.value : e;
    this.setState((s) => ({form: {...s.form, [target]: value}}));
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.load(1);
    }
  };

  returnState = async () => {
    await this.setState((state) => ({
      ...state,
      form: {
        user_id: this.props.user.id,
        search: "",
        n_pedido: "",
        since: "",
        until: "",
      },
    }));
    await this.load(1);
  };

  print = () => {
    Globals.setLoading();
    axios
      .post("admin/reports/purchases-book/download", this.state.form)
      .then((res) => {
        if (res.data.url_storage) {
          const url = `${ENV.BasePublic}${res.data.url_storage}`;
          const win = window.open(url, "_blank");
          win.focus();
        } else if (res.data.url) {
          const win = window.open(res.data.url, "_blank");
          win.focus();
        } else {
          Globals.showError("Ha ocurrido un error");
        }
      })
      .catch((err) => {
        Globals.showError();
      })
      .finally(() => {
        Globals.quitLoading();
      });
  };

  render() {
    const {form} = this.state;

    return (
      <Menu history={this.props.history}>
        <div id="home">
          <div className="row">
            {/* Buscador ampliado a col-md-4 */}
            <div className="col-md-3">
              <Input
                color=" "
                name="search"
                label="Buscar"
                placeholder="Nombre o razón social"
                className="filter"
                value={form.search}
                onChange={(e) => this.changeText(e, "search")}
                onKeyPress={this.handleKeyPress}
              />
            </div>
            <div className="col-md-2">
              <Input
                color=" "
                name="n_pedido"
                label="N° de pedido"
                placeholder="N° pedido..."
                className="filter"
                value={form.n_pedido}
                onChange={(e) => this.changeText(e, "n_pedido")}
                onKeyPress={this.handleKeyPress}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                minDate={this.state.dates.minDate}
                value={form.since}
                onChange={(value) => this.change(value, "since")}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                maxDate={this.state.dates.maxDate}
                value={form.until}
                onChange={(value) => this.change(value, "until")}
              />
            </div>
            {/* Ajustado a col-md-2 para mantener 12 columnas en total */}
            <div className="col-md-2" style={{display: "flex", gap: "0.5rem"}}>
              <Button
                className="btn-align-bottom btn-filter blue"
                color=" "
                style={{minWidth: 90}}
                onClick={() => this.load(1)}
              >
                <span>Filtrar</span>
              </Button>
              <Button
                className="btn-align-bottom btn-filter"
                color=" "
                style={{minWidth: 90}}
                onClick={this.returnState}
              >
                <span>Limpiar</span>
              </Button>
            </div>
          </div>

          <Table
            data={this.state.data.length}
            title="Registro de libro de compra"
            header={this.state.header}
            right={
              <Button title="Imprimir" small="true" onClick={this.print}>
                <img src={PrinterIcon} alt="Imprimir" />
              </Button>
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{i.n_pedido || "-"}</td>
                  <td>{i.fecha || "-"}</td>
                  <td>{i.rif || "N/A"}</td>
                  <td>{i.razon_social || "N/A"}</td>
                  <td>{i.n_factura || "-"}</td>
                  <td>{i.n_control || "-"}</td>
                  <td>{i.nota_debito || "-"}</td>
                  <td>{i.nota_credito || "-"}</td>
                  <td>{i.doc_afectado || "-"}</td>
                  <td align="right">
                    {Globals.formatMiles(Number(i.total_iva))}
                  </td>
                  <td align="right">
                    {Globals.formatMiles(Number(i.compras_extras))}
                  </td>
                  <td align="right">
                    {Globals.formatMiles(Number(i.base_16))}
                  </td>
                  <td align="right">{Globals.formatMiles(Number(i.iva_16))}</td>
                  <td align="right">{Globals.formatMiles(Number(i.base_8))}</td>
                  <td align="right">{Globals.formatMiles(Number(i.iva_8))}</td>
                  <td align="right">
                    {Globals.formatMiles(Number(i.base_31))}
                  </td>
                  <td align="right">{Globals.formatMiles(Number(i.iva_31))}</td>
                  <td align="right">
                    {Globals.formatMiles(Number(i.retencion_75))}
                  </td>
                  <td align="right">
                    {Globals.formatMiles(Number(i.retencion_100))}
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={(page) => this.load(page)}
          />
        </div>
      </Menu>
    );
  }
}

export default connect((state) => {
  return {
    user: state.user,
  };
})(PurchasesBook);
